/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Tablet = (props: IconProps) => (
  <Icon {...props}>
    <path d="M1.01,6L1,18c0,1.1,0.9,2,2,2h18c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2H3C1.9,4,1.01,4.9,1.01,6z M18,6v12H6V6H18z" />
  </Icon>
);
